import React, { useCallback, forwardRef, useImperativeHandle, Fragment } from 'react';
import PropTypes from 'prop-types';
import './ColorPicker.less'
import { colorisingEntity, updateColorPickerPos } from 'actions/livefeed'
import { SketchPicker } from 'react-color';
import { Rnd } from 'react-rnd';
import { useDispatch, useSelector } from 'react-redux'

const ColorPicker = forwardRef((props, ref) => {
    const [displayColorPicker, setDisplayColorPicker] = React.useState(false)
    const dispatch = useDispatch();
    const { colorPickerPos, livefeedSlides, slideCurrentIndex, stepNumberState } = useSelector(state => state.livefeededitor)
    const { historyEntities } = livefeedSlides[slideCurrentIndex]
    let history = historyEntities.slice();
    let currentEntity = history[stepNumberState];
    const onChangeComplete = useCallback((color) => {
        let id = currentEntity.id
        let rgba = color.rgb
        let processColor = `rgba(${rgba.r},${rgba.g},${rgba.b},${rgba.a})`
        let newColor = processColor;
        dispatch(colorisingEntity(id, newColor))
    }, [currentEntity.id, dispatch])

    function openColorPicker() {
        setDisplayColorPicker(true)
    }
    useImperativeHandle(ref, () => ({
        openColorPicker: () => {
            openColorPicker();
        }
    }));

    const onDragStop = useCallback(({ x, y }) => {
        dispatch(updateColorPickerPos({ x, y }))
    }, [dispatch])

    const enableResizing = {
        bottom: false, bottomLeft: false, bottomRight: false, left: false,
        right: false, top: false, topLeft: false, topRight: false
    }
    return (
        <Fragment>
            <div
                className={props.className}
                onClick={() => props.clickable ? openColorPicker() : null}
            >
                {props.children}
            </div>

            {displayColorPicker &&
                <Fragment>
                    <div
                        style={{
                            position: 'fixed', top: 0, bottom: 0, left: 0,
                            right: 0, zIndex: 7091
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            setDisplayColorPicker(false)
                        }} />
                    <div style={{ position: 'fixed', width: 250, height: 350.5, right: 50, top: '25%', zIndex: 7093 }}>
                        <Rnd
                            className="color-picker-drag"
                            dragHandleClassName={'draggable-place'}
                            enableResizing={enableResizing}
                            default={{
                                x: colorPickerPos.x,
                                y: colorPickerPos.y,
                                width: 250,
                                height: "auto"
                            }}
                            onDragStop={(e, d) => onDragStop({ x: d.x, y: d.y })}
                        >
                            <Fragment>
                                <div className="draggable-place">
                                    <i onClick={() => setDisplayColorPicker(false)}
                                        className="material-icons delete--icons" data-tip="Delete" currentitem="false">clear</i>
                                </div>
                                <SketchPicker
                                    width={230}
                                    color={currentEntity.color} onChangeComplete={(color) => onChangeComplete(color)} />
                            </Fragment>
                        </Rnd>
                    </div>
                </Fragment>
            }
        </Fragment>
    );
})

ColorPicker.propTypes = {
    className: PropTypes.any
}
export default ColorPicker


// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/common/ColorPicker.jsx